import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import {getDatabase} from 'firebase/database';
import {getStorage} from 'firebase/storage';
import {getAnalytics, setAnalyticsCollectionEnabled} from 'firebase/analytics';

const config = {
  apiKey: 'AIzaSyBkAgTU5qwuSsDfX7LhILS9FB4kC293euM',
  authDomain: 'zabble-zero-6e69a.firebaseapp.com',
  databaseURL: 'https://zabble-zero-6e69a.firebaseio.com',
  projectId: 'zabble-zero-6e69a',
  storageBucket: 'zabble-zero-6e69a.appspot.com',
  messagingSenderId: '1084209488658',
  appId: '1:1084209488658:web:e7fa8d3fb2aec4f49d09cb',
  measurementId: 'G-3LRLE1P2VP',
};

const INTERNAL_EMAIL_SUFFIX = '@zabbleinc.com';

const app = initializeApp(config);
// Guard analytics initialization for non-browser environments (SSR/test)
let analytics;

/**
 * Disable Analytics collection for Zabble staff (@zabbleinc.com).
 * Once disabled in a browser session, collection stays off for that session.
 */
export function disableAnalyticsForInternalUser(email) {
  if (!analytics || !email || typeof email !== 'string') {
    return;
  }
  if (email.toLowerCase().endsWith(INTERNAL_EMAIL_SUFFIX)) {
    setAnalyticsCollectionEnabled(analytics, false);
  }
}

try {
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
    // Returning staff sessions: email already in localStorage before auth re-runs
    disableAnalyticsForInternalUser(
      window.localStorage.getItem('zabble-email'),
    );
  }
} catch (e) {}

const auth = getAuth(app);
const database = getDatabase(app);
const storage = getStorage(app);

export {app, analytics, auth, database, storage};
